import produce from "immer"
import type { PagingActions, PagingOptions } from "../../models/types"
import { loadPagingOptions } from "../../utils/sort-table.utils"
import { LICENCE_LOAD, LICENCE_LOAD_DEFAULT, LICENCE_LOAD_LIST, LICENCE_LOAD_LIST_OPTIONS } from "./licence.actions"
import type { ILicenceState, Licence, LicenceActions } from "./licence.types"

const licenceInitialState: ILicenceState = {
  licence: getEmptyLicence(),
  licences: [],
  pagingOptions: {
    currentPage: 0,
    pageSize: 10,
    totalPages: 0
  }
}

export function licenceReducer(
  currentState: ILicenceState | undefined,
  action: LicenceActions | PagingActions
): ILicenceState {
  const state = currentState ?? licenceInitialState
  switch (action.type) {
    case LICENCE_LOAD: {
      return loadLicence(state, action.payload as Licence)
    }
    case LICENCE_LOAD_LIST: {
      return loadLicenceList(state, action.payload as Licence[])
    }
    case LICENCE_LOAD_LIST_OPTIONS: {
      return loadPagingOptions(state, action.payload as PagingOptions)
    }
    case LICENCE_LOAD_DEFAULT: {
      return loadLicence(state, getEmptyLicence())
    }
    default: {
      return state
    }
  }
}

function getEmptyLicence(): Licence {
  return {
    ean: "",
    name: "",
    baseLicenceId: ""
  }
}

function loadLicence(currentState: ILicenceState, licence: Licence): ILicenceState {
  return produce(currentState, (draftState: ILicenceState) => {
    draftState.licence = licence
  })
}

function loadLicenceList(currentState: ILicenceState, licences: Licence[]): ILicenceState {
  return produce(currentState, (draftState: ILicenceState) => {
    draftState.licences = licences
  })
}
